<div class="variables-panel">

  <!-- HEADER -->
  <div class="panel-header">
    <div class="panel-title">
      <mat-icon>code</mat-icon>
      <span>VARIABLES</span>
    </div>

    <div class="panel-actions">
      <button
        mat-icon-button
        class="action-btn"
        (click)="onRefresh()"
        matTooltip="Actualizar">
        <mat-icon>refresh</mat-icon>
      </button>

      <button
        mat-icon-button
        class="action-btn"
        (click)="onToggleFilters()"
        matTooltip="Filtros"
        matTooltipPosition="below"
        [disabled]="isLoading">
        <mat-icon>filter_list</mat-icon>
      </button>
    </div>
  </div>

 <!-- SEARCH -->
  <div class="search-container">
    <div class="search-row">
      <mat-form-field appearance="outline" class="search-field">
        <mat-icon matPrefix>search</mat-icon>
        <input
          matInput
          placeholder="Buscar..."
          [formControl]="searchControl"
          maxlength="100"
          autocomplete="off">

        <button
          mat-icon-button
          matSuffix
          *ngIf="searchControl.value && !hasSearchErrors"
          (click)="clearSearch()"
          matTooltip="Limpiar">
          <mat-icon>clear</mat-icon>
        </button>

        <mat-icon
          matSuffix
          *ngIf="hasSearchErrors"
          color="warn"
          matTooltip="{{searchErrorMessage}}">
          error
        </mat-icon>

        <mat-error *ngIf="hasSearchErrors">
          {{ searchErrorMessage }}
        </mat-error>
      </mat-form-field>
    </div>
  </div>

    <!-- LOADING -->
  <div *ngIf="isLoading" class="loading-container">
    <mat-spinner diameter="24"></mat-spinner>
    <span>Cargando...</span>
  </div>

  <!-- VARIABLE GROUPS -->
  <div class="groups-container" *ngIf="!isLoading">

    <div
      *ngFor="let group of filteredGroups"
      class="variable-group">

      <!-- GROUP HEADER -->
      <div
        class="group-header"
        (click)="toggleGroup(group.tipoVariable)">

        <mat-icon class="toggle-icon" [class.expanded]="isGroupExpanded(group.tipoVariable)">
          chevron_right
        </mat-icon>

        <mat-icon class="group-icon">category</mat-icon>

        <span class="group-title">{{ group.tipoVariable }}</span>

        <span class="group-count">({{ group.variables.length }})</span>
      </div>

      <!-- GROUP CONTENT -->
      <div
        class="group-content"
        [class.expanded]="isGroupExpanded(group.tipoVariable)">

        <div
          *ngFor="let variable of group.variables"
          class="variable-item"
          (click)="onVariableClick(variable)"
          (dblclick)="onVariableDoubleClick(variable)"
          [matTooltip]="getVariableTooltip(variable)"
          matTooltipClass="variable-tooltip">

          <div class="variable-header">
            <mat-icon class="variable-icon">data_object</mat-icon>
            <span class="variable-code">{{variable.codigo}}</span>
          </div>

          <div class="variable-details" *ngIf="variable.descripcion">
            <span class="variable-description">{{ variable.descripcion }}</span>
          </div>

          <div class="variable-value" *ngIf="variable.valor">
            <span class="value-label">Valor:</span>
            <span class="value-text">{{ variable.valor }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- EMPTY STATE -->
    <div *ngIf="filteredGroups.length === 0" class="empty-state">
      <mat-icon class="empty-icon">code_off</mat-icon>
      <p>No se encontraron variables</p>
      <small>Las variables aparecerán aquí cuando estén disponibles</small>
    </div>
  </div>

  <!-- HELP TEXT -->
  <div class="help-text">
    <mat-icon>info</mat-icon>
    <span>Doble-click para insertar en el editor</span>
  </div>
</div>
